"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/SIFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_206)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_206`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000244141H30V23.9998H-6V0.000244141Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 8H30V15.9998H-6V8Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 16H30V23.9998H-6V16Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.4254 7.82612V8.86934C10.4254 11.2657 7.29495 11.9998 7.29495 11.9998C7.29495 11.9998 4.16449 11.2657 4.16449 8.86934V7.82612L4.1543 4.71914L10.4151 4.70044L10.4254 7.82612Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.4254 7.82612V8.86934C10.4254 11.2657 7.29495 11.9998 7.29495 11.9998C7.29495 11.9998 4.16449 11.2657 4.16449 8.86934V7.82612L4.1543 4.71914L10.4151 4.70044L10.4254 7.82612Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.4254 7.8262V8.86943C10.4254 11.2658 7.29495 11.9999 7.29495 11.9999C7.29495 11.9999 4.16449 11.2658 4.16449 8.86943V7.8262L5.20849 8.86943L7.29495 7.3042L9.38217 8.86943L10.4254 7.8262Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_206`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as SIFlag };
